<template>
    <div class="ly-note--textcontent ly-note--oper">
        <!-- 左侧间隔层 start -->
        <div class="ly-note--edge">
            <div class="ly-note--edge_no" v-for="el in textSplit.length">
                <span>{{el}}</span>
            </div>
        </div>
        <!-- 左侧间隔层  end  -->
        <div class="ly-note--container">
            <textarea v-model="text" ref="textarea" class="ly-note--textarea" placeholder="请在此处粘贴复制的数据" :disabled="!canEdit">
            </textarea>
        </div>
        <!-- 用于锁定的层 start -->
        <div class="ly-note--lock" ref="lock" v-show="text.length > 0">
            <div class="ly-note--lock__move" @mousedown="onmousedown">
                <span><i class="fa fa-align-justify"></i></span>
            </div>
            <div class="ly-note--lock__tips">
                从第 <strong>{{spaceLen}}</strong> 行拆分，可以拆分 <strong>{{splitArrLength}}</strong> 行数据
            </div>
        </div>
        <!-- 用于锁定的层  end  -->
    </div>
</template>
<script>
    import RangFn from './rangFn'
    /**
     * 封装的多行文本输入
     */
    export default {
        props: {
            value: {
                type: String,
                default: ''
            }
        },
        mixins:[RangFn],
        data () {
            return {
                text: '', // textarea中的内容
                isMove: false,
                defHeight: 0, // textarea默认高度
                moveStartY: 0, // 开始拖动时Y轴位置
                moveStartH: 0, // 开始拖动时的高度
                moveH: 50, // 拖动过后的高度
                maxMoveH: 0, // 最大移动的高度
                minMoveH: 50, // 最小移动的高度(最小值也作为每个移动的间隔)
                spaceLen: 1, // 分隔的长度
                splitArr: [], // 分隔字符串后的数组[二维数组，按长度分隔存储]
                splitArrLength: 0, // 可以拆分出多少行数据
                textSplit: [], // 按换行符分隔的数据
                canEdit: true // 标识编辑器是否可以编辑
            }
        },
        watch: {
            text (txt) {
                if (txt.length > 0) {
                    // 内容改变后计算高度
                    this.countTextareaHeight()
                    // 计算可以拆分出多少条数据
                    this.countSplitLength()
                    // 内容分发
                    this.$emit('input', txt)
                } else {
                    this.setTextareaHeight(this.defHeight)
                }
            }
        },
        mounted () {
            if (this.value.length > 0) {
                this.text = this.value
            }
            // 获得默认高度
            this.defHeight = this.$refs.textarea.clientHeight
            // 分隔事件的监听
            this.$eventHub.$on('DO_SPLIT', this.doSplit)
        },
        methods: {
            /**
             * 字符串按指定行数的分隔
             */
            doSplit () {
                this.canEdit = false
                // 分隔后的字符串 按等份 平分
                for (let i = 0; i < this.splitArrLength; i++) {
                    this.splitArr[i] = []
                    for (let j = 0; j < this.spaceLen; j++) {
                        // 取值分隔字符串数组的索引
                        let index = j + i * this.spaceLen
                        // 获得此行的文本
                        let rowStr = this.trim(this.textSplit[index]) || ''
                        // 再将文本按空格分割
                        if (rowStr.length > 20) { // 若此行的长度超过20，那么大概率上是由多列组合到一起了，就再根据空格分割一次
                            let rowStrSplit = rowStr.split(/[\s]/)
                            rowStrSplit.forEach((el) => {
                                let s = this.trim(el)
                                if (s.length > 0) {
                                    // 为当前行加入列数据
                                    this.splitArr[i].push(s)
                                }
                            })
                        } else {
                            // 为当前行加入列数据
                            this.splitArr[i].push(rowStr)
                        }
                    }
                }
                this.canEdit = true
                // 分发拆分完成的数据
                this.$emit('spiltDone', this.splitArr)
            },
            /**
             * 计算textarea高度
             */
            countTextareaHeight () {
                // 根据换行符分隔字符串
                this.textSplit = this.text.split('\n')
                // 内容的行数
                let len = this.textSplit.length
                // 设置textarea的高度
                this.setTextareaHeight(len * 50)

                // 这里要修正lock层的高度，若textarea高度变矮，要确定lock层不能高于textarea的高度
                let textareaHeight = this.$refs.lock.clientHeight
                textareaHeight = textareaHeight < this.minMoveH ? this.minMoveH : textareaHeight  // 确定最小高度
                this.moveH = textareaHeight > this.maxMoveH ? this.maxMoveH : textareaHeight  // 确定最大高度
                this.$refs.lock.style.height = this.moveH + 'px'
            },
            /**
             * 设置textarea的高度
             */
            setTextareaHeight (height) {
                this.$refs.textarea.style.height = height + 'px'
                // 设置最大的移动高度
                this.maxMoveH = this.$refs.textarea.offsetHeight
            },
            /**
             * 设置锁定层的高度
             */
            setLockHeight () {
                // 设置按间隔的位置
                let space = this.moveH % this.minMoveH
                let spaceH = space > (this.minMoveH / 2) ? this.minMoveH : 0
                // 设置lock层的高度
                this.moveH = this.moveH - space + spaceH
                this.$refs.lock.style.height = this.moveH + 'px'
            },
            /**
             * 计算可以拆分出多少条数据
             */
            countSplitLength () {
                // 计算按第几行来分隔
                this.spaceLen = parseInt((this.maxMoveH - this.moveH) / this.minMoveH + 1)
                // 根据换行符分隔字符串
                // this.textSplit = this.text.split('\n')
                // 这里不用再拆分了，因为在内容改变的时候已经拆分过了
                let len = this.textSplit.length
                // 计算分隔成几等份
                this.splitArrLength = parseInt(len / this.spaceLen)
                if (len % this.spaceLen > 0) {
                    this.splitArrLength++
                }
            },
            /**
             * 鼠标按下
             */
            onmousedown (e) {
                this.isMove = true
                this.moveStartY = e.y
                this.moveStartH = this.$refs.lock.clientHeight
                // 添加事件监听
                document.body.addEventListener('mouseup', this.onmouseup)
                document.body.addEventListener('mousemove', this.onmousemove)
            },
            /**
             * 鼠标移动的监听
             */
            onmousemove (e) {
                if (this.isMove) {
                    // 计算拖动距离
                    let h = this.moveStartH + (this.moveStartY - e.y)
                    h = h > this.maxMoveH ? this.maxMoveH : h
                    this.moveH = h < this.minMoveH ? this.minMoveH : h
                    // 设置lock层的高度
                    this.$refs.lock.style.height = this.moveH + 'px'
                    // 让textarea失去焦点
                    this.$refs.textarea.blur()
                }
            },
            /**
             * 鼠标松开
             */
            onmouseup (e) {
                this.isMove = false
                // 设置锁定层的高度
                this.setLockHeight()
                // 计算可以拆分出多少数据
                this.countSplitLength()
                // 移除事件监听
                document.body.removeEventListener('mouseup', this.onmouseup)
                document.body.removeEventListener('mousemove', this.onmousemove)
            }
        },
        destroyed () {
            // 销毁事件的监听
            this.$eventHub.$off('DO_SPLIT', this.doSplit)
        }
    }
</script>

<style>
    .ly-note--container {
        overflow: hidden;
    }
    .ly-note--textcontent {
        position: relative;
        width: 100%;
        height: 100%;
        padding-bottom: 50px;
    }
    .ly-note--textcontent .ly-note--textarea {
        width: 10000px;
        overflow-x: auto;
    }
    .ly-note--lock {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        min-height: 50px;
        background-color: rgba(255, 255, 255, .8);
        z-index: 9;
        border-top: 1px solid #ebdfd5;
    }
    .ly-note--lock__move {
        position: absolute;
        left: 50%;
        top: -13px;
        margin-left: -13px;
        width: 20px;
        height: 20px;
        font-size: 14px;
        color:#b9a691;
        text-align: center;
        line-height: 20px;
        padding: 2px;
        overflow: hidden;
        border-radius: 50%;
        background-color: #fff;
        background-image: -webkit-radial-gradient(center center, #f1f1f1,#fff);
        border:1px #b9a691 solid;
        box-shadow: 0 0 8px #ebdfd5;
        cursor: move;
    }
    .ly-note--lock__tips {
        text-align: center;
        color:#b9a691;
        line-height: 50px;
    }
</style>
